import AssignmentOutlinedIcon from '@mui/icons-material/AssignmentOutlined';
import { useIsEntitySignupFormUser } from '@vs/hooks/hook-is-entity-signup-form-user';
import { PortalMenu } from '@vs/ui/portal/menu';
import { useTranslation } from 'react-i18next';

export default function EntitySignupEntry() {
  const { t } = useTranslation('shared');
  const { isUser } = useIsEntitySignupFormUser();

  return (
    isUser && (
      <>
        <div className="vs-body-xs-regular text-vs-base-content-variant leading-5 px-6 pt-4">
          {t('avatar_menu.more_options')}
        </div>
        <PortalMenu
          open
          menuItemList={[
            {
              name: t('avatar_menu.entity_signup_form'),
              icon: <AssignmentOutlinedIcon className={'me-2'} />,
              url: `${window.location.origin}/entity/sign-up-form`,
            },
          ]}
        />
        <div className="border-vs-neut-300 border-t mx-6"></div>
      </>
    )
  );
}
